import { DatePipe } from "@angular/common";
import { Injectable, OnInit } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { appService } from "../../../_services/app.service";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { Helpers } from "../../../../app/helpers";
// Added by priya - 23/01/2026 - Common service for eway bill Api's - cn(PRIYA-JAN26-013)
@Injectable()
export class EwayBillService {

  constructor(
    private _appService: appService,
    private translate: TranslateService,
    private toastr: ToastrService,
    private datePipe: DatePipe,
    private modalService: NgbModal
  ) { }

  // Added by priya - 23/01/2026 - Getting eway Lr data - cn(PRIYA-JAN26-013)
  GetEwayLrData(BookingId, ConsignmentDetailId): Promise<any> {
    var ConsignmentList = [];
    return new Promise((resolve, reject) => {
      this._appService.GetByTwoId("BookingOrigin", "NewEway_GetLrData", BookingId, ConsignmentDetailId).subscribe(
      (response) => {
        var resObjArray: any = [];
        resObjArray = response;
        if (resObjArray.length > 0) {
          if (resObjArray[0].ProductListJson != null) {
            resObjArray[0].ProductList = JSON.parse(resObjArray[0].ProductListJson);
          }
          var obj: any = {};
          obj = resObjArray[0];
          var totalInvoiceAmnt: any = 0;
          if (obj.ProductList && obj.ProductList.length > 0) {
            obj.ProductList.forEach(item => {
              totalInvoiceAmnt = totalInvoiceAmnt + item.InvoiceAmount;
            });
          }
          totalInvoiceAmnt = parseFloat(totalInvoiceAmnt as any).toFixed();
          obj.TotalInvoiceAmount = totalInvoiceAmnt;
          ConsignmentList.push(obj);
        }
        resolve(ConsignmentList);
      },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "error");
        reject(err);
      });
    });
  }

  // Added by priya - 23/01/2026 - Generate eway part B - cn(PRIYA-JAN26-013)
  GenerateEwayPartB(data, UserId, BookingId, ConsignmentDetailId): Promise<any> {
    return new Promise((resolve, reject) => {
      var partBList: any = [];
      var isSuccess = false;
      var errorMessage = '';
      Helpers.setLoading(true);
      data.forEach(ele => {
        var obj: any = {};
        obj.UserId = UserId;
        obj.cndId = ele.cndId;
        obj.place_of_consignor = ele.place_of_consignor;
        obj.state_of_consignor = ele.state_of_consignor;
        obj.ewayCreatedDate = ele.ewayCreatedDate;
        obj.TransporterGST = ele.TransporterGST;
        obj.eway_bill_number = ele.eway_bill_number;
        obj.vehicle_number = ele.vehicle_number;
        obj.vehicle_type = ele.vehicle_type;
        obj.reason_code_for_vehicle_updation = ele.reason_code_for_vehicle_updation;
        obj.reason_for_vehicle_updation = ele.reason_for_vehicle_updation;
        obj.transporter_document_number = ele.transporter_document_number;
        obj.transporter_document_date = ele.transporter_document_date;
        obj.mode_of_transport = ele.mode_of_transport;
        obj.data_source = ele.data_source;
        partBList.push(obj);
      });
      this._appService.Post("BookingOrigin", "GenerateEWayBillPartB", partBList).subscribe(
        (response) => {
          Helpers.setLoading(false);
          response.forEach((item) => {
            if (item.message === 'PartB Generated Successfully') {
              isSuccess = true;
              return;
            }
            if (!errorMessage && item.message) {
              try {
                var parsed = JSON.parse(item.message.trim());
                if (parsed && parsed.results && parsed.results.message) {
                  errorMessage = parsed.results.message;
                } else {
                  errorMessage = item.message;
                }
              } catch (e) {
                errorMessage = item.message;
              }
            }
          });
          // if (isSuccess) {
          //   this.toastr.success('PartB Generated Successfully!', 'success');
          // } else if (errorMessage) {
          //   this.toastr.warning(errorMessage, 'error');
          // }
          // resolve(response);
          if (isSuccess) {
            resolve({ success: true, response });
          } else {
            resolve({ success: false, errorMessage });
          }
        },
        (err) => {
          Helpers.setLoading(false);
          this.toastr.error(err._body.replace(/"/g, ""), "error");
          reject(err);
        });
    });
  }

  // Added by priya - 23/01/2026 - Print eway bill - cn(PRIYA-JAN26-013)
  PrintEwayBill(eWayBillNo, GstinNo, UserId, BookingId) {
    return new Promise((resolve, reject) => {
      Helpers.setLoading(true);
      this._appService.GetByFourId("BookingOrigin", "PrintEwayBill", eWayBillNo, GstinNo, UserId, BookingId).subscribe(
        (response) => {
          Helpers.setLoading(false);
          if (response && response.Error) {
            this.toastr.error(response.Error);
            reject(response.Error);
          } else {
            resolve(response); // ✅ just return data
          }
        },
        (err) => {
          Helpers.setLoading(false);
          this.toastr.error("Error occurred while fetching data !", "error");
          reject(err);
        });
    });
  }

  // Added by priya - 23/01/2026 - Verify eway bill - cn(PRIYA-JAN26-014)
  VerifyEwayBill(eWayBillNo, GstinNo, UserId, ConsignmentDetailId) {
    return new Promise((resolve, reject) => {
      Helpers.setLoading(true);
      let obj: any = {
        OrdersByVehicleId: ConsignmentDetailId,
        eway_bill_number: eWayBillNo,
        gstin: GstinNo,
        UserId: UserId
      }
      this._appService.Post("BookingOrigin", "GetEWayBillData", obj).subscribe(
        (response) => {
          Helpers.setLoading(false);
          // if (response && response[0].message == "EWay Verified Successfully") {
          //   this.toastr.error(response[0].message);
          //   resolve(response[0].message); // ✅ just return data
          // } else {
          //   reject(response);
          // }
          const apiMessage = response[0].message || '';
          if (apiMessage === "EWay Verified Successfully") {
            this.toastr.success(apiMessage);
            resolve(apiMessage);
          } else {
            // ✅ SHOW ERROR MESSAGE FROM API
            this.toastr.error(apiMessage || "EWay verification failed");
            reject(apiMessage);
          }
        },
        (err) => {
          Helpers.setLoading(false);
          this.toastr.error(err._body.replace(/"/g, ""), "Error");
          reject(err);
        });
    });
  }

  // Added by priya - 27/01/2026 - Getting verified eway bill data - cn(PRIYA-JAN26-014)
  GetVerifiedEwayBillData(ConsignmentDetailId, EwayBillNo): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService.GetByTwoId("BookingOrigin", "GetVerifiedEWayBillData", ConsignmentDetailId, EwayBillNo).subscribe(
        (response) => {
          resolve(response);
        },
        (err) => {
          this.toastr.error(err._body.replace(/"/g, ""), "error");
          reject(err);
        });
    });
  }

  // Added by priya - 27/01/2026 - Getting eway bill log data - cn(PRIYA-JAN26-014)
  GetEwayBillLog(Start, Length, SearchValue, UserId, ConsignmentDetailId, BookingId, OrderId) {
    return new Promise((resolve, reject) => {
      Helpers.setLoading(true);
      let obj: any = {
        Start: Start,
        Length: Length,
        SearchValue: SearchValue,
        UserId: UserId,
        ConsignmentDetailId: ConsignmentDetailId,
        BookingId: BookingId,
        OrderId: OrderId
      }
      this._appService.Post("BookingOrigin", "GetEwayBillLog", obj).subscribe(
        (response) => {
          Helpers.setLoading(false);
          resolve(response);
        },
        (err) => {
          Helpers.setLoading(false);
          this.toastr.error(err._body.replace(/"/g, ""), "Error");
          reject(err);
        });
    });
  }

  // Added by priya - 30/01/2026 - Extend eway validity - cn(PRIYA-JAN26-015)
  ExtendEwayValidity(data, UserId, BookingId, ConsignmentDetailId): Promise<any> {
    var partBList: any = [];
    var isSuccess = false;
    var errorMessage = '';
    Helpers.setLoading(true);
    return new Promise((resolve, reject) => {
      data.forEach(ele => {
        var obj: any = {};
        obj.UserId = UserId;
        obj.cndId = ele.cndId;

        obj.userGstin = ele.TransporterGST;
        obj.eway_bill_number = ele.eway_bill_number;
        obj.vehicle_number = ele.vehicle_number;
        obj.place_of_consignor = ele.place_of_consignor;
        obj.state_of_consignor = ele.state_of_consignor;
        obj.remaining_distance = ele.RemainingDistance;
        obj.transporter_document_number = ele.transporter_document_number;
        obj.transporter_document_date = ele.transporter_document_date;
        obj.mode_of_transport = ele.mode_of_transport;
        obj.extend_validity_reason = ele.ValidityReason;
        obj.extend_remarks = ele.ExtendRemarks;
        // obj.consignment_status = ele.consignment_status;
        obj.consignment_status = 'M';
        obj.from_pincode = ele.PickupPincode;
        // obj.transit_type = ele.transit_type;
        // obj.address_line1 = ele.PickupCity;
        // obj.address_line2 = ele.PickupCity;
        // obj.address_line3 = ele.PickupCity;
        partBList.push(obj);
      });
      
      this._appService.Post("BookingOrigin", "GenerateEWayBillValidityExtend", partBList).subscribe(
        (response) => {
          Helpers.setLoading(false);
          response.forEach((item) => {
            if (item.message === 'EWayBill Canceled Successfully') {
              isSuccess = true;
              return;
            }
            if (!errorMessage && item.message) {
              try {
                var parsed = JSON.parse(item.message.trim());
                if (parsed && parsed.results && parsed.results.message) {
                  errorMessage = parsed.results.message;
                } else {
                  errorMessage = item.message;
                }
              } catch (e) {
                errorMessage = item.message;
              }
            }
          });
          if (isSuccess) {
            resolve({ success: true, response });
          } else {
            resolve({ success: false, errorMessage });
          }
        },
        (err) => {
          Helpers.setLoading(false);
          this.toastr.error(err._body.replace(/"/g, ""), "error");
          reject(err);
        });
    });
  }

  // Added by priya - 31/01/2026 - checking duplicate ewaybill - cn(PRIYA-JAN26-015)
  CheckDuplicateEwayBillNo(ConsignmentDetailId, EwayBillNo): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService.GetByTwoId("BookingOrigin", "CheckDuplicateEwayBillNo", ConsignmentDetailId, EwayBillNo).subscribe(
        (response) => {
          resolve(response);
        },
      )
        // (err) => {
        //   this.toastr.error(err._body.replace(/"/g, ""), "error");
        //   reject(err);
        // });
    });
  }

  // Added by priya - 03/02/2026 - Getting Validity reason - cn(PRIYA-JAN26-016)
  GetValidityReason(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService.GetById("Common", "GetLookByCategoryName", "ExtendEwayBillReason").subscribe(
        (response) => {
          response.map((x) => {
            x.name = x.Label;
            x.value = x.Id;
          });
          resolve(response);
        },
        (err) => {
          this.toastr.error(err._body.replace(/"/g, ""), "error");
          reject(err);
        });
    });
  }

}
